import { render, staticRenderFns } from "./DeleteMusic.vue?vue&type=template&id=4d4fd7e1&scoped=true&"
import script from "./DeleteMusic.vue?vue&type=script&lang=js&"
export * from "./DeleteMusic.vue?vue&type=script&lang=js&"
import style0 from "./DeleteMusic.vue?vue&type=style&index=0&id=4d4fd7e1&scoped=true&lang=css&"
import style1 from "@/assets/css/musicManagement.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4fd7e1",
  null
  
)

export default component.exports